import script from "./FamilyConnector.vue?vue&type=script&lang=ts&setup=true"
export * from "./FamilyConnector.vue?vue&type=script&lang=ts&setup=true"

import "./FamilyConnector.vue?vue&type=style&index=0&id=7ac05df5&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7ac05df5"]])

export default __exports__